import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../base/firestore-model-base'

/** 郵送対象1件（Doc） */
export type CompanySurveySendTargetDoc = {
  management_id: string
  document_id: string
}

/** 郵送対象1件（アプリ用） */
export type CompanySurveySendTarget = {
  managementId: string
  documentId: string
}

/** Firestoreに保存される形（送信先リスト1件＝1郵送確定）。回答期限・受付終了はフォーム（company_survey_form）で管理。 */
export type CompanySurveySendListDoc = FirestoreBaseDoc & {
  /** 郵送回（この確定時に付与した番号） */
  request_number: string
  /** 郵送対象事業所の managementId と documentId の対応 */
  send_targets: CompanySurveySendTargetDoc[]
}

/** アプリで使う形 */
export type CompanySurveySendList = AppBase & {
  requestNumber: string
  sendTargets: CompanySurveySendTarget[]
}

export const companySurveySendListDocConverter = makeDocConverter<CompanySurveySendListDoc>()

export function toCompanySurveySendList(
  id: string,
  doc: CompanySurveySendListDoc,
  path: string,
): CompanySurveySendList {
  const sendTargets: CompanySurveySendTarget[] = (doc.send_targets ?? []).map((t) => ({
    managementId: t.management_id,
    documentId: t.document_id,
  }))

  return {
    ...baseFromDoc(id, doc, path),
    requestNumber: doc.request_number ?? '',
    sendTargets,
  }
}
